import { WalletExtensionRdns as e, WalletType as t } from "../../constants/web3.js";
import { CustomError as r } from "../../errors/customError.js";
const l = (n) => {
  switch (n) {
    case e.Metamask:
      return t.Metamask;
    case e.Okx:
      return t.Okx;
    case e.Ronin:
      return t.Ronin;
    case e.WalletConnect:
      return t.WalletConnect;
    default:
      throw new r(`Invalid wallet rnds ${n}`);
  }
};
export {
  l as walletRdnsToType
};
//# sourceMappingURL=walletRdnsToType.js.map
